import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Alert, AlertType } from './alert.model';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private subject: Subject<Alert> = new Subject<Alert>();

  constructor() {
  }

  onNext(): Observable<Alert> {
    return this.subject.asObservable();
  }

  showInfo(message: string, translateParams = {}, hasSuffix = false): void {
    this.addNext(AlertType.Primary, message, translateParams, hasSuffix);
  }

  showDanger(message: string, translateParams = {}, hasSuffix = false): void {
    this.addNext(AlertType.Danger, message, translateParams, hasSuffix);
  }

  showWarning(message: string, translateParams = {}, hasSuffix = false): void {
    this.addNext(AlertType.Warning, message, translateParams, hasSuffix);
  }

  // add other types if needed (alert.model.ts/AlertType)

  private addNext(type: AlertType, message: string, translateParams = {}, hasSuffix = false): void {
    this.subject.next(new Alert(type, message, translateParams, hasSuffix));
  }
}
